export default function Skeleton() {
  return (
    <div className="page">
      <header className="topbar">
        <div className="topbar__inner">
          <div className="brand">
            <div className="brand__mark skeleton" style={{ width: 36, height: 36, borderRadius: 10 }} />
            <div className="brand__text">
              <div className="skeleton skeleton-line" style={{ width: 140, height: 12 }} />
              <div className="skeleton skeleton-line" style={{ width: 90, height: 10, marginTop: 6 }} />
            </div>
          </div>
        </div>
      </header>
      <main className="layout">
        <section className="video-col">
          <div className="video-wrap skeleton" style={{ borderRadius: 16 }} />
          <div className="actions">
            <div className="skeleton skeleton-pill" />
            <div className="skeleton skeleton-pill" />
            <div className="skeleton skeleton-pill" />
          </div>
        </section>
        <aside className="sidebar">
          <div className="skeleton skeleton-line" style={{ width: 120, height: 10, marginBottom: 16 }} />
          <div className="agent-card">
            <div className="skeleton" style={{ width: 96, height: 96, borderRadius: "50%", margin: "8px auto" }} />
            <div className="skeleton skeleton-line" style={{ width: 100, height: 14, margin: "12px auto 6px" }} />
            <div className="skeleton skeleton-line" style={{ width: 70, height: 10, margin: "0 auto" }} />
          </div>
        </aside>
      </main>
    </div>
  );
}
